<template>
  <div >
    <div class="footer_style">

    <div class="bottom-social-w3ls">
<!--      <h2 class="footer-logo"><a href="#"><span>A</span>irwork</a></h2>-->
      <nav>
        <ul class="nav-w3ls">
          <li v-for="(item,i) in menuList"><router-link :to="item.url"  >{{item.name}}</router-link></li>

<!--          <li><router-link to="/">首页</router-link></li>-->

<!--          <li><router-link to="/company">公司介绍</router-link></li>-->

<!--          <li><router-link to="/product">产品</router-link></li>-->

<!--          <li><router-link to="/newsPage">新闻资讯</router-link></li>-->

<!--          <li><router-link to="/contact">联系我们</router-link></li>-->



        </ul>

      </nav>
      <!--<div class="w3ls-social-icons">-->
        <!--<a class="facebook" href="#"><span class="fa fa-facebook"></span></a>-->
        <!--<a class="twitter" href="#"><span class="fa fa-twitter"></span></a>-->
        <!--<a class="pinterest" href="#"><span class="fa fa-pinterest-p"></span></a>-->
        <!--<a class="linkedin" href="#"><span class="fa fa-linkedin"></span></a>-->
      <!--</div>-->
      <div class="copy">

        <div class="copy_right">©Copyright {{logoList.copyright}} 版权所有
<!--          <a href="" target="_blank" title="模板之家">沪ICP备：18047198号 </a>-->
        </div>
        <div class="copy_case">
          <img src="../../images/copyrightIcon1.png">
            <img src="../../images/copyright2.png">
          <a href="https://beian.miit.gov.cn/" title="" target="_blank"> {{logoList.internetRecord}}</a>
        </div>
      </div>
       <div class="erweima-content">
         <img class="erweima" src="../../images/erweima.jpg" alt="">
         <h3 class="lern-more">关注公众号了解更多</h3>
       </div>
    </div>

    <!--/footer -->
    <a href="#" id="toTop" style="display: block;"> <span id="toTopHover" style="opacity: 1;"> </span></a>
   
    </div>
  </div>
</template>



<style scoped>
  .nav-w3ls{
    text-align: left;
    width: 80%;
    margin: 20px auto;
  }

  .copy{
    text-align: left;
    width: 80%;
    margin: 20px auto;
  }

  .copy_right{
    color: #4c4f4f;
  }
  .copy_case>a{
    color: #4c4f4f;
  }
  .copy_right>a{
    color: #4c4f4f;
  }

  .footer_style{

    /*padding: 0 2em;*/
  }

  .copy_case img{
    display: inline-block;
    height: 18px;
    width: 18px;
  }

</style>

<script>
    import mixins from '../../common/mixin';
    import application from '../../common/application'
    export default {
        name: "header",
        mixins:[mixins],
        data:()=>({
            application:application,
            menuList:[],
            logoList:{}
        }),
        created(){
            this.handleTab();
            this.handleLogo();
        },
        mounted(){
            $(function () {
                $('.button_nav').on('click', function() {

                    $("#menu").removeClass("in");

                });

            });
        },
        methods:{
            handleTab(){
                this.request({
                    url: '/web/menu/list',
                    data:{
                        "pageIndex": 0,
                        "pageSize": 10,

                    },
                    success: (response) => {

                        this.menuList=response.data.records;

                        // console.log(this.menuList)


                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            },
            handleLogo(){
                this.request({
                    url: '/web/introduce/detail',
                    data:{
                        id:8

                    },
                    success: (response) => {

                        this.logoList=response.data;

                        console.log('',this.logoList)


                    },
                    error: (response) => {
                        this.$Message.error(response.message);
                    },
                    complete: () => {
                    }
                });
            }

        }

    }
</script>



// WEBPACK FOOTER //
// src/components/footer/footer.vue